"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      rotate = _ref.rotate,
      className = _ref.className,
      _ref$dataTestid = _ref['data-testid'],
      dataTestId = _ref$dataTestid === void 0 ? 'icon' : _ref$dataTestid;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " icon icon--thin-arrow fill-").concat(color),
    style: {
      width: "".concat(width, "px"),
      transform: "rotate(".concat(rotate, "deg)"),
      height: "".concat(height, "px")
    },
    viewBox: "0 0 40 40",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.52 21.225c.312-.311.48-.73.48-1.139 0-.407-.156-.827-.48-1.138L29.23 8.662a1.615 1.615 0 00-2.291 0 1.613 1.613 0 000 2.29l7.532 7.516H1.619c-.9 0-1.619.72-1.619 1.619s.72 1.618 1.62 1.618h32.85l-7.531 7.529a1.613 1.613 0 000 2.29 1.615 1.615 0 002.29 0L39.52 21.224z"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_610_835"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h40v40H0z"
  }))));
}